import "./why-accordion";
import "./mission-accordion";
import "./industry-tab";
import "./advantage-slider";
import "./service-card";
import "./service-circular-slider";
import "./obstacle-loop";
import "./experts-accordion";
// import "./maintenance-accordion";
import "./themes/_themes";

import videoLazyLoad from "./videoLazyLoad";
videoLazyLoad();